<app-modal title="Nuovo movimento">
    <app-cash-flow-details [mode]="'modal'" [external_record]="record" [id_address]="id_address" ></app-cash-flow-details>
</app-modal>